import { createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit"
import type { RootState } from "../reducers/store"
import {
  agentSignal,
  selectLiveTurn,
  turnExpired,
  turnSent,
} from "../reducers/agentPipelineSlice"
import { turnAnswered } from "../reducers/agentTurnActions"
import { rttAppend, rttNew, rttReset } from "../reducers/rttSlice"

// The agent answers a turn that runs too long with a fallback body itself, so
// this only ends a turn nothing else will: a crashed agent or a lost answer.
export const AGENT_TURN_TIMEOUT_MS = 180_000

const isTurnActivity = isAnyOf(
  turnSent,
  agentSignal,
  turnAnswered,
  rttNew,
  rttAppend,
  rttReset,
)

const agentTurnExpiryListener = createListenerMiddleware()

agentTurnExpiryListener.startListening({
  matcher: isTurnActivity,
  effect: async (action, listenerApi) => {
    const { roomJid } = action.payload
    if (!selectLiveTurn(listenerApi.getState() as RootState, roomJid)) return
    // Any later activity in the room starts its own wait, so this one ends.
    const touched = await listenerApi.condition(
      (next) => isTurnActivity(next) && next.payload.roomJid === roomJid,
      AGENT_TURN_TIMEOUT_MS,
    )
    if (!touched) listenerApi.dispatch(turnExpired({ roomJid }))
  },
})

export default agentTurnExpiryListener
